import {Field} from 'formik';
import {FormikCheckbox} from '@shipwell/shipwell-ui';

const ContainerStopCheckboxFieldBase = ({name, label}: {name: string; label: string}) => (
  <Field name={name} label={label} component={FormikCheckbox} />
);

export default ContainerStopCheckboxFieldBase;
